/**
 * Role-code constants mirroring m46-parking's own ROLES object
 * (packages/modules/m46-parking/src/constants.ts), so every page checks the
 * same literal strings the API gates on instead of re-typing them.
 */
export const PARKING_ROLES = {
  ENFORCEMENT_OFFICER: 'ENFORCEMENT_OFFICER',
  PARKING_SUPERVISOR: 'PARKING_SUPERVISOR',
  PARKING_ADMIN: 'PARKING_ADMIN',
} as const;

export function hasAnyRole(roles: string[] | undefined, ...check: string[]): boolean {
  if (!roles) return false;
  return check.some((r) => roles.includes(r));
}
